<template>
    <div class="Form__group" :class="{'required': required}">
        <label v-if="label">{{ label }}</label>
        <textarea-autosize v-if="type==='textarea'" :placeholder="placeholder" @input="handleChange"
                           class="Input" :value="value"
                           :max-height="150"
                           :min-height="100"
                           :important="true"
        />
        <input v-else :placeholder="placeholder" @input="e => handleChange(e.target.value)"
               class="Input Input--textarea" :type="type" :value="value">
        <span class="form-error" v-if="error">{{ error[0] }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'text'
            },
            required: {
                type: Boolean,
                default: false
            },
            value: {
                required: true
            },
            label: {
                required: false
            },
            placeholder: {
                required: false,
                default: ''
            },
            error: {
                default: null
            }
        },
        methods: {
            handleChange: function (value) {
                this.$emit('input', value);
            }
        }
    }
</script>
